import { useCallback, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const MAX_HISTORY_LENGTH = 10

export const useHistorianNavigation = () => {
  const history = useHistory()
  const location = useLocation<{
    skipHistoryUpdate?: boolean
  }>()

  useEffect(() => {
    const currentPath = location.pathname
    const navHistory = JSON.parse(localStorage.getItem('nav_history') || '[]')

    if (!location.state?.skipHistoryUpdate) {
      if (currentPath !== navHistory[navHistory.length - 1]) {
        navHistory.push(currentPath)
        if (navHistory.length > MAX_HISTORY_LENGTH) {
          navHistory.shift()
        }
        localStorage.setItem('nav_history', JSON.stringify(navHistory))
      }
    }
  }, [location])

  const goBack = useCallback(() => {
    const navHistory = JSON.parse(localStorage.getItem('nav_history') || '[]')
    if (navHistory.length > 1) {
      navHistory.pop() // Remove current page
      const previousPage = navHistory.pop() // Get previous page
      localStorage.setItem('nav_history', JSON.stringify(navHistory))
      history.push(previousPage)
    } else {
      history.push('/launch') // Fallback to home if no history
    }
  }, [history])

  return { goBack }
}
